import {FlowType, IFlow} from "../constants/flowType";
import { buyBookFlow, copyBookFlow, copyCardFlow } from "../payment/Flows";

const flows: Partial<Record<FlowType, IFlow>> =  {
    [FlowType.BUY_BOOK]: buyBookFlow,
    [FlowType.COPY_BOOK]: copyBookFlow,
    [FlowType.COPY_CARD]: copyCardFlow,
}

export const usePaymentFlow = (flowType: FlowType) => {
    const currentFlow = flows[flowType]

    return {currentFlow}
}import {FlowType, IFlow} from "../constants/flowType";
import { buyBookFlow, copyBookFlow, copyCardFlow } from "../payment/Flows";

const flows: Partial<Record<FlowType, IFlow>> =  {
    [FlowType.BUY_BOOK]: buyBookFlow,
    [FlowType.COPY_BOOK]: copyBookFlow,
    [FlowType.COPY_CARD]: copyCardFlow,
}

export const usePaymentFlow = (flowType: FlowType) => {
    const currentFlow = flows[flowType]

    return {currentFlow}
}